// Code review - In Progress
// Documentation - In Progress
import { useEffect } from "react";
import { mainTable } from "../css/Common";
import { useState } from "react";
import { languageMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import LanguagePopup from "../popup-containers/LanguagePopup";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import Loader from "../ReusableComponents/Loader";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const LanguageMaster = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [bindLanguageMasterDatas, setBindLanguageMasterDatas] = useState([]);
  const [mstLanguageId, setMstLanguageId] = useState("");
  const [languageData, setLanguageData] = useState("");

  //popup title state

  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getLanguageData();
  }, []);

  const getLanguageData = async () => {
    setIsLoading(true);
    try {
      const response = await BindAPI("LanguageAPI/GetLanguage");
      setBindLanguageMasterDatas(response?.data?.Table ?? []);
    } catch (error) {
      console.error("Error fetching languages:", error);
      setBindLanguageMasterDatas([]); // fallback in case of error
    } finally {
      setIsLoading(false);
    }
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };

  const cancel = () => {
    getLanguageData();
    setIsLoading(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    handleOpen(false);
    setSubmitBtnDisabled(false);
    setIsLoading(false);
    setLanguageFields({
      language: "",
      languageCode: "",
    });

    setLanguageFieldsError({
      languageError: "",
      languageCodeError: "",
    });
  };
  //Value store States
  const [languageFields, setLanguageFields] = useState({
    language: "",
    languageCode: "",
  });

  const [languageFieldsError, setLanguageFieldsError] = useState({
    languageError: "",
    languageCodeError: "",
  });

  const validate = (flag) => {
    const errors = {};
    if (flag === 1 || flag === 2) {
      if (!languageFields.language.trim()) {
        errors.language = "Enter language";
      } else if (!/^[A-Za-z ]+$/.test(languageFields.language)) {
        errors.language = "Only alphabet and space allowed";
      }
      if (!languageFields.languageCode.trim()) {
        errors.languageCode = "Enter language Code";
      } else if (
        !/^[a-z]{2}(-[A-Za-z ]{2})?$/.test(languageFields.languageCode)
      ) {
        errors.languageCode = "Language code has to be in 2 letters and lowercase";
      }
    }
    setLanguageFieldsError({
      ...languageFieldsError,
      languageError: errors.language || "",
      languageCodeError: errors.languageCode || "",
    });
    return errors;
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    const validation = validate(flag);
    if (Object.keys(validation).length !== 0) {
      setIsOpen(true);
    }
    if (Object.keys(validation).length === 0) {
      setIsOpen(false);
      setIsLoading(true);
      var createdBy = sessionStorage.getItem("createdBy");
      if (flag == 1) {
        const languagePayload = [
          {
            languageKey: languageFields.languageCode,
            language: languageFields.language,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(
          languagePayload,
          "LanguageAPI/IUDLanguage"
        );
        if (response.data.Table[0].Result == "S") {
          toast.success("Language added successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
          getLanguageData();
        } else {
          toast.error(
            " Language addition failed. Please review the details and try again. 👎",
            {
              duration: 1000,
              position: "top-center",
            }
          );
          setTimeout(cancel, 1000);
        }
      } else if (flag == 2) {
        const languagePayload = [
          {
            mstLanguageId: mstLanguageId,
            languageKey: languageFields.languageCode,
            language: languageFields.language,
            createdBy: createdBy,
            flag: flag,
          },
        ];

        const response = await IUDAPI(
          languagePayload,
          "LanguageAPI/IUDLanguage"
        );
        if (response.data.Table[0].Result == "M") {
          toast.success("Language Modified successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
          getLanguageData();
        } else {
          toast.error(
            " Language modify failed. Please review the details and try again. 👎",
            {
              duration: 1000,
              position: "top-center",
            }
          );
          setTimeout(cancel, 1000);
        }
      } else {
        const languagePayload = [
          {
            mstLanguageId: bindLanguageMasterDatas[items].MstLanguageId,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(
          languagePayload,
          "LanguageAPI/IUDLanguage"
        );
        if (flag == 3) {
          if (response.data.Table[0].Result == "D") {
            toast.success("Deletion successful! 🗑️", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            getLanguageData();
          } else {
            toast.error(
              " Language delete failed. Please review the details and try again. ❌",
              {
                duration: 1000,
                position: "top-center",
              }
            );
            setTimeout(cancel, 1000);
          }
        } else if (flag == 4) {
          if (response.data.Table[0].Result == "B") {
            toast.success("Language blocked successfully. 🔒", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            getLanguageData();
          } else {
            toast.error(
              "Language block failed. Please review the details and try again.",
              {
                duration: 1000,
                position: "top-center",
              }
            );
            setTimeout(cancel, 1000);
          }
        } else if (flag == 5) {
          if (response.data.Table[0].Result == "UB") {
            toast.success("Language unblocked successfully. 🔓", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            getLanguageData();
          } else {
            toast.error(
              "Language unblocked failed. Please review the details and try again.",
              {
                duration: 1000,
                position: "top-center",
              }
            );
            setTimeout(cancel, 1000);
          }
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      
    }
  };

  const handleEdit = (rowIndex) => {
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setLanguageFields({
      language: bindLanguageMasterDatas[rowIndex].Language,
      languageCode: bindLanguageMasterDatas[rowIndex].LanguageKey,
    });
    setMstLanguageId(bindLanguageMasterDatas[rowIndex].MstLanguageId);
    setLanguageData(bindLanguageMasterDatas[rowIndex]);
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };
  useEffect(() => {
    if (location.pathname == "/languagemaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
      getLanguageData();
    }
  }, [location]);
  const handleLanguagePopUp = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
      setRowIndex(rowIndex);
    }
    setLanguageData(bindLanguageMasterDatas[rowIndex]);
  };
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      {visibleTable && (
        <GridPage
          title="Language Master"
          header={languageMasterHeader}
          records={bindLanguageMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleLanguagePopUp}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="flex flex-col w-full">
          <div class={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Language Master"
            />
          </div>

          <div class="mx-auto  md:w-2/5 w-full border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <div class="flex w-full gap-6">
                      <div class="w-full">
                        <div class={`mb-2`}>
                          <InputText
                            inputType="text"
                            title="language"
                            name="language"
                            classStar={"text-red-400"}
                            content={languageFields.language}
                            controlFunc={(e) =>
                              setLanguageFields({
                                ...languageFields,
                                language: e.target.value,
                              })
                            }
                            controlFuncBlur={(e) => {
                              setLanguageFieldsError((languageFieldsError) => ({
                                ...languageFieldsError,
                                languageError:
                                  languageFields.language &&
                                  languageFields.language.length > 0
                                    ? /^[A-Za-z ]+$/.test(
                                        languageFields.language
                                      )
                                      ? ""
                                      : "Only Alphabet and space allowed"
                                    : "Enter Language",
                              }));
                            }}
                            errorMessage={languageFieldsError.languageError}
                          />
                        </div>
                        <div>
                          <InputText
                            inputType="text"
                            title="Language Code"
                            name="languageCode"
                            classStar={"text-red-400"}
                            content={languageFields.languageCode}
                            controlFunc={(e) =>
                              setLanguageFields({
                                ...languageFields,
                                languageCode: e.target.value,
                              })
                            }
                            controlFuncBlur={(e) => {
                              setLanguageFieldsError((languageFieldsError) => ({
                                ...languageFieldsError,
                                languageCodeError:
                                  languageFields.languageCode &&
                                  languageFields.languageCode.length > 0
                                    ? /^[a-z]{2}(-[A-Za-z ]{2})?$/.test(
                                        languageFields.languageCode
                                      )
                                      ? ""
                                      : "Language code has to be in 2 letters and lowercase"
                                    : "Enter Language Code",
                              }));
                            }}
                            errorMessage={languageFieldsError.languageCodeError}
                          />
                        </div>
                      </div>
                    </div>

                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleLanguagePopUp}
      >
        <div>
          <PopUpScreenTitle
            title="Language Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <LanguagePopup data={languageData} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default LanguageMaster;
